import store from "@/store";

const loader = {
  on: () => store.commit("loader/SET_LOADING", true),
  off: () => store.commit("loader/SET_LOADING", false),
};

export default loader;
